import { makeAutoObservable } from 'mobx';

import EmailStore from './EmailStore';
import MobileNumberStore from './MobileNumberStore';
import { PrepaidBrand } from './models/IPrepaidInfo';
import PopulationRegistryPersonStore from './PopulationRegistryPersonStore';
import PriceStore from './PriceStore';
import ReferenceNumberStore from './ReferenceNumberStore';
import SessionStore from './SessionStore';

class PrepaidDataStore {
  public loading = false;
  public referenceNumber: string;
  public brand: PrepaidBrand;
  public isErrorNotificationVisible = true;

  constructor(
    private mobileNumberStore: MobileNumberStore,
    private priceStore: PriceStore,
    private emailStore: EmailStore,
    private sessionStore: SessionStore,
    private referenceNumberStore: ReferenceNumberStore,
    private populationRegistryPersonStore: PopulationRegistryPersonStore,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public submitForm = async (): Promise<void> => {
    await this.validateDataAndGoToNextStep();
    this.setIsErrorNotificationVisible(true);
  };

  public setIsErrorNotificationVisible(isErrorNotificationVisible: boolean) {
    this.isErrorNotificationVisible = isErrorNotificationVisible;
  }

  private async validateDataAndGoToNextStep(): Promise<any> {
    this.setLoading(true);

    await this.emailStore.validateEmail();
    if (await this.mobileNumberStore.validateMobileNumber()) {
      this.setBrand(this.mobileNumberStore.prepaidInfo.brand);
    }

    if (this.brand) {
      await this.priceStore.tryLoadPrices(this.mobileNumberStore.mobileNumber);
      const referenceNumber = await this.referenceNumberStore.findReferenceNumber(this.mobileNumberStore.mobileNumber);
      this.setReferenceNumber(referenceNumber);
    }

    this.setLoading(false);
  }

  private setLoading(isLoading: boolean) {
    this.loading = isLoading;
  }

  private setBrand(brand: PrepaidBrand) {
    this.brand = brand;
  }

  private setReferenceNumber(number: string) {
    this.referenceNumber = number;
  }

  get showEmailComponent(): boolean {
    return !this.sessionStore.isDealer;
  }

  get isStepDone(): boolean {
    if (!this.mobileNumberStore.validMobileNumber || this.priceStore.priceItems?.length === 0) {
      return false;
    }

    if (this.emailStore.orderInvoice && !this.emailStore.email) {
      return false;
    }

    if (this.sessionStore.isDealer && this.mobileNumberStore.detaineeNumber) {
      return this.populationRegistryPersonStore.isValidPersonalCode && this.populationRegistryPersonStore.personName.length > 0;
    }

    return true;
  }
}

export default PrepaidDataStore;
